"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
function delayUnmounting(Component) {
    return /** @class */ (function (_super) {
        tslib_1.__extends(class_1, _super);
        function class_1() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.state = {
                shouldRender: _this.props.isMounted
            };
            return _this;
        }
        class_1.prototype.componentWillReceiveProps = function (nextProps) {
            var _this = this;
            if (this.props.isMounted && !nextProps.isMounted) {
                setTimeout(function () { return _this.setState({ shouldRender: false }); }, this.props.delayTime);
            }
            else if (!this.props.isMounted && nextProps.isMounted) {
                this.setState({ shouldRender: true });
            }
        };
        class_1.prototype.render = function () {
            return this.state.shouldRender ? react_1["default"].createElement(Component, tslib_1.__assign({}, this.props)) : null;
        };
        return class_1;
    }(react_1["default"].Component));
}
exports["default"] = delayUnmounting;
